import './tripStops.css';
import {useState} from "react";
import {format} from "date-fns";
import UtilityService from "../../services/utility.service";
import GeoLocation from "../../shared/geoLocation/geoLocation";
import Placeholder from "../../shared/placeholder/placeholder";
const TripStops = (
    {
        alerts = [],
        selectedAlert,
        getSelectedAlert = (alert) => {},
        loader = false
    }) => {
    const [activeAlert, setActiveAlert] = useState(selectedAlert);
    const getCurrentStep = (alert) => {
        getSelectedAlert(alert);
        setActiveAlert(alert);
    }

    return(
        <>

            {loader &&
                <ul className={`grid gap-15`}>
                    {[1, 2, 3, 4, 5, 6, 7, 8].map((load) =>
                        <li key={load}><Placeholder height={'50px'} round={'8px'}/></li>)}
                </ul>
            }
            {!loader &&
                <ul className={'trip-steps page-fade-in font-13 sf-medium'}>
                    <li className={'from'}>
                        <div className="place font-14 margin-b-3">Peenya, Bangalore</div>
                        <div className="grey-font">14:32  |   12th Aug 2018</div>
                    </li>
                    <ul className={'trip-steps steps-container'}>
                        {
                            alerts?.filter(alert => alert.isActive !== false).map((alert) =>

                                <li key={alert.externalAlertId} className={`step ${alert?.externalAlertId === selectedAlert?.externalAlertId ? 'current' : ''}`}
                                    onClick={event => getCurrentStep(alert)}>
                                    {/*<div className="">{mapAlert.info.area}</div>*/}
                                    {/*<div className={`${mapAlert.type}`}>{mapAlert.info.warning}</div>*/}
                                    <div className={`alert-name ${alert.alertType}`}>{UtilityService.getAlertName(alert?.alertType)}</div>
                                    <ul className="separator gap-15 margin-b-5">
                                        <li>{(alert.speed)?.toFixed(1)}km/h</li>
                                        <li>{format(new Date(`${alert?.timestampInISO}`), 'HH:mm')}</li>
                                        <li>{format(new Date(`${alert?.timestampInISO}`), 'do MMM yyyy')}</li>
                                    </ul>
                                    <div className="grey-color">
                                        <GeoLocation lat={alert?.location?.coordinates[1]} lng={alert?.location?.coordinates[0]}/>
                                    </div>
                                </li>
                            )
                        }
                    </ul>
                    <li className={'to padding-t-10'}>
                        <div className="">Nungambakkam, Chennai</div>
                        <ul className="separator grey-font gap-15">
                            <li>5:48</li>
                            <li>13th Aug 2018</li>
                        </ul>
                    </li>
                </ul>
            }
        </>
    )
}

export default TripStops;
